"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var web3_1 = __importDefault(require("web3"));
var InjectedProviderStrategy = /*#__PURE__*/function () {
  function InjectedProviderStrategy() {
    (0, _classCallCheck2["default"])(this, InjectedProviderStrategy);
  }
  (0, _createClass2["default"])(InjectedProviderStrategy, [{
    key: "getProvider",
    value: function getProvider(rpcs) {
      var injected = window.ethereum;
      if (!injected) {
        throw new Error('No injected provider found');
      }
      return injected;
    }
  }, {
    key: "requestConnection",
    value: function requestConnection(provider) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(provider == null)) {
                _context.next = 3;
                break;
              }
              window.open('https://metamask.io/', '_blank');
              return _context.abrupt("return");
            case 3:
              _context.next = 5;
              return provider.request({
                method: 'eth_requestAccounts'
              });
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
    }
  }, {
    key: "requestDisconnection",
    value: function requestDisconnection(provider) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
    }
  }, {
    key: "requestChangeNetwork",
    value: function requestChangeNetwork(provider, chainId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return provider.request({
                method: 'wallet_switchEthereumChain',
                params: [{
                  chainId: "0x".concat(chainId.toString(16))
                }]
              });
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
    }
  }, {
    key: "getPreviosSession",
    value: function getPreviosSession(provider) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
        var web3, accounts;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(provider == null)) {
                _context4.next = 2;
                break;
              }
              return _context4.abrupt("return", null);
            case 2:
              web3 = new web3_1["default"](provider);
              _context4.next = 5;
              return web3.eth.getAccounts();
            case 5:
              accounts = _context4.sent;
              if (!(accounts.length === 0)) {
                _context4.next = 8;
                break;
              }
              return _context4.abrupt("return", null);
            case 8:
              return _context4.abrupt("return", provider);
            case 9:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
    }
  }]);
  return InjectedProviderStrategy;
}();
exports["default"] = InjectedProviderStrategy;